// extracted by mini-css-extract-plugin
module.exports = {"hero":"WorkspaceHero_hero__ZMtsZ","imageError":"WorkspaceHero_imageError__XeldZ"};